export type Theme = 'system' | 'light' | 'dark';

// a local setting, never synced; index.html reads it too, before the page
// first paints
const KEY = 'theme';

// the page's background in each scheme, for the browser's own bars
const BARS = { light: '#fdfdfc', dark: '#181817' };

// storage can be off, or throw, in a private window
export const savedTheme = (): Theme => {
  try {
    const theme = localStorage.getItem(KEY);
    return theme === 'light' || theme === 'dark' ? theme : 'system';
  } catch {
    return 'system';
  }
};

// a picked scheme is set on the root; without one the device's applies
export const applyTheme = (theme: Theme) => {
  const root = document.documentElement;
  if (theme === 'system') delete root.dataset.theme;
  else root.dataset.theme = theme;
  document.querySelectorAll<HTMLMetaElement>('meta[name=theme-color]')
    .forEach(meta => {
      const own = meta.media.includes('dark') ? 'dark' : 'light';
      meta.content = BARS[theme === 'system' ? own : theme];
    });
  window.notesAndroid?.setTheme(theme);
};

export const saveTheme = (theme: Theme) => {
  try {
    if (theme === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, theme);
  } catch {}
  applyTheme(theme);
};
